import React from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import { Option } from 'carbon-react/lib/components/select';
import SimpleSelect from 'carbon-react/lib/components/select/simple-select';

import { ForecastTypeFilterValues } from '../../../types';

interface TypeShownFilterProps {
  onChange: (value: string) => void;
  selectedValue: ForecastTypeFilterValues;
}

export const TypeShownFilter = ({ onChange, selectedValue }: TypeShownFilterProps) => {
  const intl = useIntl();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const options = [
    {
      value: ForecastTypeFilterValues.ALL,
      label: intl.formatMessage({ id: 'predict.filters.forecast_type.all', defaultMessage: 'All' })
    },
    {
      value: ForecastTypeFilterValues.THREE_WAY_FORECASTS,
      label: intl.formatMessage({
        id: 'predict.filters.forecast_type.3_way_forecasts',
        defaultMessage: '3-way forecasts'
      })
    },
    {
      value: ForecastTypeFilterValues.P_AND_L_BUDGETS,
      label: intl.formatMessage({
        id: 'predict.filters.forecast_type.p_and_l_budgets',
        defaultMessage: 'P&L budgets'
      })
    }
  ];

  return (
    <Box width={250}>
      <SimpleSelect
        label={intl.formatMessage({
          id: 'predict.filters.forecast_type.type_shown',
          defaultMessage: 'Type shown'
        })}
        value={selectedValue}
        onChange={handleChange}
      >
        {options.map(option => (
          <Option key={option.value} value={option.value} text={option.label}>
            {option.label}
          </Option>
        ))}
      </SimpleSelect>
    </Box>
  );
};
